// 點擊信箱驗證結果 (A010-2 / A010-3)
<template>
  <CustomRow>
    <v-card v-if="!pageLoading" class="mt-5 text-center cusPadding">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="10" sm="8">
          <div>
            <template v-if="verifyResult">
              <v-img src="@/assets/image/images-register-done@3x.png" :width="imageWidth" class="mx-auto mb-5"></v-img>
              <div class="mt-8 mb-10 text-huge-title font-weight-bold">
                {{ $t('validation_email_valid_title') }}
              </div>
              <div class="text-title font-weight-bold">
                {{ $t('validation_email_valid_content') }}
              </div>
            </template>
            <template v-else>
              <v-img src="@/assets/image/images-mail-fail@3x.png" :width="imageWidth" class="mx-auto mb-5"></v-img>
              <div class="mt-8 mb-10 text-huge-title font-weight-bold">
                {{ $t('validation_email_invalid_title') }}
              </div>
              <div class="text-title font-weight-bold">
                {{ $t('validation_email_invalid_content') }}
              </div>
            </template>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="10" sm="4" md="3" class="mt-6 font-weight-bold">
          <v-btn v-if="verifyResult" class="nextBtn" depressed block x-large @click="goIndexAndLogin()">{{
            $t('validation_email_cta') }}</v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-card>
  </CustomRow>
</template>

<script>
import UM from "@/api/user-management";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      pageLoading: true,
      verifyResult: false
    };
  },
  metaInfo() {
    return {
      title: `${this.$t('validation_email_title')} - ${this.$t('app_name')}`,
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.$t('validation_email_title')} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  computed: {
    imageWidth() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
        return "100";
      else return "120";
    }
  },
  async mounted() {
    const key = this.$route.query.key;
    if (!key) {
      this.showDialog({
        alert: true,
        content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('pwd_link_error')}</div>
          </div>`
      });
      setTimeout(() => {
        this.reLogin();
      }, 2000);
    } else {
      this.$store.dispatch("setOverlayLoading", true);
      const { data } = await UM.verifyEmail(key);
      // console.log(`${String.fromCodePoint(128049)} [UM] verifyEmail`, data);
      // if (data.errCode !== "00")
      //   alert(`${data.errCode}\n${data.errMsg}\n${data.errDetail}`);
      // todo handle error
      switch (data.errCode) {
        case "00":
          this.verifyResult = true;
          break;
        case "101":
          // 傳入參數有誤
          break;
        case "102":
          // 內部系統錯誤
          break;
        case "104":
          // 找不到 key || 驗證過期
          break;
        default:
          break;
      }
      this.$store.dispatch("setOverlayLoading", false);
      this.pageLoading = false;
    }
  },
  methods: {
    ...mapActions({
      logout: "user/logout",
      showLogin: "login/show",
      showDialog: "dialog/show",
      setRelogin: "login/relogin",
    }),
    goIndexAndLogin() {
      this.setRelogin(true);
      this.logout();
      this.$router.push({ name: 'Index' }).catch(() => { });
    }
  }
};
</script>

<style lang="scss" scoped>
.cusPadding {
  padding: 50px 20px;
}
</style>
